import { FC } from 'react';
import classNames from 'classnames';
import { CardContent } from 'lib/components';

export interface SelectPlanCardContentProps {
  className?: string;
}

export const SelectPlanCardContent: FC<SelectPlanCardContentProps> = ({ className, ...props }) => (
  <CardContent className={classNames(`lg:pr-[280px]`, className)} {...props} />
);
